import { useQuery } from '@tanstack/react-query';
import { doc, getDoc } from 'firebase/firestore';
import { firestore } from '../services/firebase';

export const useFiltersSettings = () => {
    const SETTINGS = "settings";
    const CUSTOMIZATION = "customization";

    return useQuery({
        queryKey: [CUSTOMIZATION, 'settings'],
        queryFn: async () => {
            try {
                const docRef = doc(firestore, CUSTOMIZATION, SETTINGS);
                const snapshot = await getDoc(docRef);

                if (!snapshot.exists()) {
                    return null; // filtros desabilitados
                }

                const data = snapshot.data();

                return {
                    prefilterByTagFirst: !!data.prefilterByTagFirst,
                };
            } catch (err) {
                console.warn('[useFiltersSettings] erro ao buscar settings:', err);
                return null;
            }
        },
        staleTime: 1000 * 60 * 5, // 5 minutos
    });
};
